import { PlansStore as Store } from './PlansStore'

export { usePlansStore } from './usePlansStore'
export type { TPlan } from './types'

export const PlansStore = new Store()
